import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, logError } from "../lib/api";

// Loads one admin endpoint; `pick` extracts the piece of the response to keep.
function useAdminResource(path, label, pick, params) {
  const [value, setValue] = useState(null);
  const load = useCallback(async () => {
    try { const { data } = await api.get(path, params ? { params } : undefined); setValue(pick(data)); }
    catch (e) { logError(`${label} failed`, e); toast.error(`Couldn't load ${label}. Please retry.`); }
  }, [path, label, pick, params]);
  return [value, load, setValue];
}

const whole = (d) => d;
const regsOf = (d) => d.registrations;
const logsOf = (d) => d.logs;

export function useAdminData(navigate) {
  const [authed, setAuthed] = useState(null);
  const [filters, setFilters] = useState({ q: "", status: "", referral: "" });

  useEffect(() => {
    api.get("/admin/me").then(() => setAuthed(true)).catch(() => { setAuthed(false); navigate("/admin"); });
  }, [navigate]);

  const [stats, loadStats] = useAdminResource("/admin/stats", "overview stats", whole);
  const [regs, loadRegs] = useAdminResource("/admin/registrations", "registrations", regsOf, filters);
  const [gifts, loadGifts] = useAdminResource("/admin/gifts", "jersey gifts", whole);
  const [config, loadConfig, setConfig] = useAdminResource("/admin/config", "configuration", whole);
  const [audit, loadAudit] = useAdminResource("/admin/audit", "the audit log", logsOf);
  const [spons, loadSpons] = useAdminResource("/admin/sponsorships", "sponsorships", whole);

  return { authed, filters, setFilters, stats, loadStats, regs: regs || [], loadRegs, gifts, loadGifts, config, loadConfig, setConfig, audit: audit || [], loadAudit, spons, loadSpons };
}
